import React from "react";
import Dialog from "../dialog";
import CloseIcon from "../../icons/closeIcon";
import styles from "./style.module.css";

const TutorialModal = ({
  open,
  onClose,
  title = "Tutorial",
  content,
}) => {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="680px">
      <div className={styles.tutorial_modal}>
        <div className={styles.tutorial_modal_header}>
          <div className={styles.tutorial_modal_header_title}>{title}</div>
          <button
            type="button"
            className={styles.tutorial_modal_header_close}
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <div className={styles.tutorial_modal_content}>
          {content}
        </div>
      </div>
    </Dialog>
  );
};

export default TutorialModal;
